import { RxCross2 } from "react-icons/rx";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { updateMessageOptions } from "../../../../store/Slices/MessageOptionsSlice";
import TextTranslate from "../../../../utils/TextTranslate";

export default function ForwardSelectedMessage() {
  const MessageOptions = useAppSelector((state) => state.MessageOptions);
  const dispatch = useAppDispatch();
  const count = MessageOptions?.message_list?.Records?.length || 0;
  if (!count) return null;

  return (
    <div className="absolute inset-x-0 bottom-0 z-40 flex w-full items-center justify-center bg-primary/95 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 backdrop-blur-sm sm:bg-primary/90 md:bg-transparent md:backdrop-blur-none">
      <div className="flex h-14 w-[90%] items-center justify-between gap-3 rounded-xl bg-messageHead px-4 shadow-sm xl:w-[90%] xl:px-6">
        <div className="flex items-center gap-3">
          <RxCross2
            onClick={() => {
              dispatch(
                updateMessageOptions({
                  message_list: {
                    Records: [],
                    Pagination: {
                      total_pages: 0,
                      total_records: 0,
                      current_page: 0,
                      records_per_page: 0,
                    },
                  },
                  forward_message: false,
                  selectMessage: false,
                }),
              );
            }}
            className="cursor-pointer text-xl"
          />
          <div>
            {count} <TextTranslate text="messages" />
          </div>
        </div>
        <button
          type="button"
          onClick={() => {
            dispatch(
              updateMessageOptions({
                show_forward_message_modal: true,
              }),
            );
          }}
          className="relative min-h-10 w-fit overflow-hidden rounded-lg px-4 text-base primary-gradient outline-none lg:px-9 lg:text-lg"
        >
          <TextTranslate text="Forward To" />
        </button>
      </div>
    </div>
  );
}
